// uuid одной операции редактора зон: все запросы одного «Сохранить» несут его в X-Zones-Batch,
// бэк делает по нему один снимок филиала и группирует записи истории
export function newZonesBatch () {
  if (window.crypto && typeof window.crypto.randomUUID === 'function') return window.crypto.randomUUID()
  const hex = []
  for (let i = 0; i < 32; i++) hex.push(Math.floor(Math.random() * 16).toString(16))
  hex[12] = '4'
  hex[16] = (8 + Math.floor(Math.random() * 4)).toString(16)
  return hex.join('').replace(/^(.{8})(.{4})(.{4})(.{4})(.{12})$/, '$1-$2-$3-$4-$5')
}

export function batchHeaders (batchId) {
  return batchId ? { headers: { 'X-Zones-Batch': batchId } } : {}
}
